<template>
  <div class="leave-auction">
    <div class="popup__text">
      You have already opened the auction "{{ payload.Name }} Lane {{ payload.Lane }}" in another session. Do you want
      to close it and reopen it?
    </div>
    <div class="popup__buttons theme--dark">
      <div class="btn btn--main btn--md btn--block btn--flex" @click="leaveAuction">Yes</div>
      <div class="btn btn--sm btn--primary btn--icon" @click="closePopup">Cancel</div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {REMOVE_JOIN_AUCTION, SET_LOT, SHOW_POPUP} from "@/store/mutations.type";

export default {
  props: ['payload', 'close'],
  name: "LiveAuction",
  methods: {
    ...mapMutations({removeJoinAuction: REMOVE_JOIN_AUCTION, SHOW_POPUP, SET_LOT}),
    leaveAuction() {
      var self = this;
      this.$iaaiService.iaaiClient.engine.KickDuplicateUser(self.payload.InternalAuctionId)
          .then(function () {
            self.SHOW_POPUP(false);
            self.removeJoinAuction(self.payload.InternalAuctionId);
            self.$iaaiService.iaaiClient.join("iaai", self.payload.ExternalAuctionId);
          })
          .catch(function (error) {
            console.log('error', error)
          })
    },
    closePopup() {
      var self = this;
      this.$iaaiService.iaaiClient.engine.LeaveAuction(self.payload.InternalAuctionId)
          .then(function () {
            self.close();
          })
          .catch(function (error) {
            console.error('error', error)
          })
    }
  }
}
</script>

<style lang="scss">

</style>